import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  fontSize,
  brandColours,
  standardColours,
  fontWeights,
  minBreakpointQuery,
  sectionPaddings,
} from '../styles';
import { Container, Heading } from './ui';

const StyledNewsletterSignup = styled.section`
  ${sectionPaddings()};
  background-color: ${brandColours.transparentSecondary(0.5)};
`;

const StyledContainer = styled(Container)`
  text-align: center;
  max-width: 640px;
`;

const StyledSignupHeader = styled(Heading)`
  color: ${standardColours.black};
  ${fontSize(25)};

  ${minBreakpointQuery.small`
    ${fontSize(35)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(45)};
  `}
`;

const StyledText = styled.p`
  margin-top: 20px;
  text-align: center;
  line-height: 170%;

  ${minBreakpointQuery.smedium`
    ${fontSize(18)};
    margin-top: 40px;
  `}
`;

const StyledForm = styled.form`
  color: ${standardColours.grey};
  margin-top: 20px;
  display: grid;
  grid-template-columns: 4fr 1fr;

  ${minBreakpointQuery.small`
    height: 75px;
    margin-top: 50px;
  `}
`;

const StyledInput = styled.input`
  padding: 20px;
  outline: none;
  border-radius: 0px;
  border: 1px solid ${standardColours.grey};
  background-color: ${standardColours.white};
  ${fontSize(16)};

  ${minBreakpointQuery.small`
    ${fontSize(20)};
  `}

  ::placeholder {
    color: ${standardColours.darkGrey};
  }
`;

const StyledButton = styled.button`
  padding: 16px;
  border-radius: 0px;
  border: 1px solid ${standardColours.darkGrey};
  background-color: ${brandColours.tertiary};
  color: ${standardColours.white};
  font-weight: ${fontWeights.bold};
  width: 110px;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
    padding: 20px;
    width: 150px;
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(20)};
    width: 170px;
  `}
`;

const NewsletterSignup = () => {
  const {
    datoCmsNewsletterSignup: { heading, text },
  } = useStaticQuery(graphql`
    query NewsletterSignupQuery {
      datoCmsNewsletterSignup {
        heading
        text
      }
    }
  `);

  return (
    <StyledNewsletterSignup>
      <StyledContainer>
        <StyledSignupHeader>{heading}</StyledSignupHeader>
        {text && <StyledText>{text}</StyledText>}
        <StyledForm
          action="https://downlandbedding.us21.list-manage.com/subscribe/post?u=0b9bae97db4a45b866355ce3d&amp;id=15c66e609e&amp;f_id=005aeee6f0"
          method="post"
        >
          <StyledInput
            type="email"
            name="EMAIL"
            placeholder="Email address"
            required
          />
          <StyledButton>Subscribe</StyledButton>
        </StyledForm>
      </StyledContainer>
    </StyledNewsletterSignup>
  );
};

export default NewsletterSignup;
